import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({
            email: null,
            password: null,
            formError: null,
        });
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.route != this.props.route) {
            const dialog = document.getElementById('login-modal');

            if (dialog) {
                if (nextProps.route == 'login' && !nextProps.user.logged_in && !this.props.user.logged_in) {
                    this.props.trackEvent(['Modal', 'show', 'Login']);
                    dialog.showModal();
                    return false;
                } else if (nextProps.route == 'login') {
                    this.props.routeTo('');
                } else if (this.props.route == 'login'){
                    this.props.trackEvent(['Modal', 'close', 'Login']);
                    dialog.close();
                    return false;
                }
            }
        }

        return true;
    }

    componentDidMount() {
        const that = this;
        const dialog = document.getElementById('login-modal');
        dialogPolyfill.registerDialog(dialog); //eslint-disable-line no-undef

        dialog.addEventListener('keydown', (e) => {
            if (e.keyCode == 13) {
                that.validate();
            } else if (e.keyCode == 27) {
                e.preventDefault();
                that.close();
            }
        });

        dialog.addEventListener('click', (e) => {
            if (e.target.tagName == 'DIALOG') {
                that.close();
            }
        });

        if (this.props.route && this.props.route == 'login') {
            that.props.trackEvent(['Modal', 'show', 'Login']);
            dialog.showModal();
        }
    }

    render({ emailError, passwordError, product }) {
        let title = 'Welcome!';
        let subtitle = 'We’re so happy to see you! Log in or signup to get started.';
        let button_text = 'ENTER';

        if (product && product.type) {
            title = `your ${product.type} awaits!`;
            subtitle = `Log in or sign up below for your ${product.type}. It's easy!`;
            button_text = `GET MY ${product.type}!`.toUpperCase();
        }

        return (
            <responsive-login-modal>
                <dialog id='login-modal'>
                    <dialog-header>
                        <button class='button-close' onClick={this.close}>×</button>
                        <h1>{title}</h1>
                        <h5>{subtitle}</h5>
                    </dialog-header>
                    <dialog-content>
                        <row>
                            <column>
                                <label>Your Email</label>
                                <input
                                  type='email'
                                  class={emailError ? 'error' : ''}
                                  onKeyup={this.setEmail}
                                />
                                {this.renderError(emailError)}
                            </column>
                        </row>
                        <row>
                            <column>
                                <label>Password</label>
                                <input
                                  type='password'
                                  class={passwordError ? 'error' : ''}
                                  onKeyup={this.setPassword}
                                />
                                {this.renderError(passwordError)}
                            </column>
                        </row>
                        <row>
                            <column>
                                {this.renderError(this.state.formError)}
                            </column>
                        </row>
                        <row>
                            <column class='has-text-centered'>
                                <button class='button-modal' onClick={this.validate}>{button_text}</button>
                                <a href='/password-reset' class='forgot-password'>Forgot your password?</a>
                            </column>
                        </row>
                    </dialog-content>
                </dialog>
            </responsive-login-modal>
        );
    }

    renderError = (error) => {
        if (error) {
            return (
                <span class='error-message'>{error}</span>
            );
        }

        return null;
    }

    close = () => {
        this.props.trackEvent(['Modal', 'close', 'Login']);
        this.props.routeTo('');
    }

    setEmail = (e) => {
        this.setState({
            email: e.target.value,
        });
    }

    setPassword = (e) => {
        this.setState({
            password: e.target.value,
        });
    }

    validate = () => {
        const validEmail = this.state.email && this.isValidEmail(this.state.email);
        const validPassword = this.state.password && this.state.password.length > 3;

        if (validEmail && validPassword) {
            this.props.userUpdate({
                emailError: null,
                passwordError: null,
            });

            this.props.userLogin({
                email: this.state.email,
                password: this.state.password,
            });
        } else {
            if (validEmail) {
                this.props.userUpdate({ emailError: null });
            } else {
                this.props.userUpdate({ emailError: 'Please enter a valid email.'});
            }

            if (validPassword) {
                this.props.userUpdate({ passwordError: null });
            } else {
                this.props.userUpdate({ passwordError: 'Please enter a password longer than 3 characters.'});
            }
        }
    }

    isValidEmail = (email) => {
        const atpos = email.indexOf('@');
        const dotpos = email.lastIndexOf('.');
        return !(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    product: state.product,
    route: state.route,
    emailError: state.user && state.user.emailError,
    passwordError: state.user && typeof state.user.passwordError === 'boolean'
        ? 'Password did not match this email'
        : state.user.passwordError,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: route => dispatch({ type: 'route:to', payload: route }),
    userUpdate: payload => dispatch({ type: 'user:update', payload: payload }),
    userLogin: payload => dispatch({ type: 'user:login', payload: payload }),
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


// WEBPACK FOOTER //
// ./app/components/responsive/login-modal.js